import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import Multiselect from 'vue-multiselect';
import currentLang from '../../js/lib/currentLang';
//import Debounce from '../../js/lib/debounce';

const courseCatalog = document.getElementById('CourseCatalog');

const options = {
	headers: {
		"content-type": "application/json; charset=utf-8"
	}
};

function arrayIncludesValue (container, value) {
    var returnValue = false;
	var pos = container.indexOf(value);
    if (pos >= 0) {
        returnValue = true;
    }
    return returnValue;
}

if(courseCatalog)
{
    // define the item component
	var CourseListComponent = Vue.component('course-list', {
	    template: '#course-list',
	    props: ['filters'],
	    data () {
	        return {
				courseList: [],
				isLoading: true
	        }
	    },
	    computed: {
	        filteredCourseList: function () {
	            return this.courseList.filter(course => course.matching == true);
			}
	    },

	    mounted: function() {
			const self = this;

			this.$nextTick(function () {
				var langParam = currentLang();
				if (langParam)
					langParam = "?lang=" + langParam;
				request().get("/CourseCatalogPage/CourseList" + langParam).then(function (response) {
					self.courseList = response;
					self.isLoading = false;
				});
			});
	    },

	    watch: {
	        // whenever input changes, this function will run
	        filters: 
	        {
	            handler: 'applyFilters',
                deep: true
	        }
	    },
	    methods: {
	        applyFilters : function()
	        {
				for (var i = 0; i < this.courseList.length; i++) 
				{
					var courseNameMatch = this.compareFiltersToCourses(this.filters.selectedNames,this.courseList[i].name);
					var durationMatch = this.compareFiltersToCourses(this.filters.selectedDurations,this.courseList[i].duration);
					var categoryMatch = this.compareFiltersToCourses(this.filters.selectedCategories, this.courseList[i].categories);
					var languageMatch = this.compareFiltersToCourses(this.filters.selectedLanguages,this.courseList[i].availableLanguages);
					var designationMatch = this.compareFiltersToCourses(this.filters.selectedDesignations, this.courseList[i].designations.map(x => x.name));

	                if(courseNameMatch && durationMatch && categoryMatch && designationMatch && languageMatch)
	                {
	                    this.courseList[i].matching = true;
	                }
	                else
	                {
	                    this.courseList[i].matching = false;
					}
	            }
			},
			compareFiltersToCourses : function(selectedFilters, courseProperty)
			{

				if(selectedFilters.length == 0)
				{
					return true;
				}
				else if(Array.isArray(courseProperty))
				{
					var hasValue = false;
					courseProperty.forEach(element => {
						if (arrayIncludesValue(selectedFilters, element))
						{
							hasValue = true;
						}
					});

					return hasValue;
				}
				else if(arrayIncludesValue(selectedFilters, courseProperty))
				{
					return true;
				}
				else
				{
					return false;
				}
			}
	    }
	});

	const courseCatalogVue = new Vue({
	    el: '#CourseCatalog',
	    components: {
	        Multiselect,
		    'courseList-component': CourseListComponent,
	    },
	    data () {
			return {
	            selectedFilters: {
	                selectedNames: '',
                    selectedDurations: '',
                    selectedCategories: '',
                    selectedLanguages: '',
                    selectedDesignations: '',
	            },
	            catalogFilterOptions: {
	                coursePageNameFilters: [],
                    durationFilters: [],
                    categoryMetadataFilters: [],
                    availableLanguageFilters: [],
                    designationFilters: [],
	            },
	        }
	    },
		mounted: function() {
			const self = this;

			var langParam = currentLang();
			console.log(langParam);
			if (langParam)
				langParam = "?lang=" + langParam;

			request().get("/CourseCatalogPage/CatalogFilters" + langParam).then(function (response) {
				self.catalogFilterOptions = response;
			});

			this.$nextTick(function () {
				self.isLoading = false;
			});
		}
	});
}



// WEBPACK FOOTER //
// ../components/course-catalog/course-catalog.js